import { useCallback, useEffect, useState } from 'react';
import { IServerConfig } from '../../server/Models/IServerConfig';

/** Fetched singleton config. */
let fetchedConfig: IServerConfig | undefined = undefined;

const useServerConfig = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string>();
  const [config, setConfig] = useState<IServerConfig | undefined>();

  const refetch = useCallback(async () => {
    if (fetchedConfig) {
      setLoading(false);
      setConfig(fetchedConfig);
    } else {
      setLoading(true);
      setError(undefined);
      return fetch('/env')
        .then((res) => res.json())
        .then((config) => {
          fetchedConfig = config;
          setConfig(config);
        })
        .catch((err) => setError(`${err}`))
        .finally(() => setLoading(false));
    }
  }, []);
  useEffect(() => {
    refetch();
  }, [refetch]);
  return { config, loading, error };
};

export default useServerConfig;
